module.exports = __webpack_public_path__ + "media/images/harry-vardon.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/harry-vardon.jpg
// module id = 66
// module chunks = 0